import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorVerifiedAd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M10.397 1.911a2.273 2.273 0 0 1 3.206 0l.001.002 1.744 1.744h2.73a2.273 2.273 0 0 1 2.265 2.266V8.652l1.746 1.746a2.273 2.273 0 0 1 0 3.204l-.002.002-1.744 1.744V18.077a2.273 2.273 0 0 1-2.266 2.266H15.348l-1.744 1.744-.001.002a2.273 2.273 0 0 1-3.205 0l-.002-.002-1.744-1.744H5.923a2.273 2.273 0 0 1-2.266-2.266V15.348l-1.744-1.744-.002-.001a2.273 2.273 0 0 1 0-3.205l.002-.002 1.744-1.744V5.923a2.273 2.273 0 0 1 2.266-2.266H8.652l1.744-1.744.001-.002Zm1.058 1.064L9.273 5.157H5.927a.773.773 0 0 0-.77.77v3.346l-2.182 2.182a.775.775 0 0 0 0 1.09l2.182 2.182v3.346a.773.773 0 0 0 .77.77h3.346l2.182 2.182a.775.775 0 0 0 1.09 0l2.182-2.182h3.347a.773.773 0 0 0 .77-.77v-3.346l2.181-2.182a.775.775 0 0 0 0-1.09l-2.181-2.182V5.926a.773.773 0 0 0-.77-.77h-3.347l-2.182-2.181a.776.776 0 0 0-1.09 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="m12 17.581-4.784-8.77h2.392L12 13.595l2.392-4.784h2.392L12 17.58Z"
    />
  </svg>
);
export default SvgTwoColorVerifiedAd;
